<template>
  <div>
    <v-btn
      fab
      @click="showList = !showList"
      :bottom="true"
      dark
      :right="true"
      class="alert"
      color="#3363FF"
    >
      <v-icon>mdi-bell-ring</v-icon>
    </v-btn>
    <v-card tile v-show="showList" class="alert-detail">
      <div class="header">
        <h3>Debe permitir las notificaciones para poder recibirlas</h3>
      </div>
      <img :src="notificationImage" alt="Notificaciones" />
    </v-card>
  </div>
</template>
<script>
export default {
  data: () => ({
    showList: true,
    fab: false,
    isMobile: window.innerWidth <= 480,
  }),

  computed: {
    notificationImage() {
      return this.isMobile
        ? "/img/notificaciones_mobile.webp"
        : "/img/notificaciones_desktop.webp";
    },
  },

  mounted() {
    this.showList = true;
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    handleResize() {
      this.isMobile = window.innerWidth <= 480;
    },
  },
};
</script>
<style scoped>
@media (min-width: 481px) {
  .centered {
    margin-right: 491px !important;
  }
}
.alert {
  max-width: 342px;
  -webkit-box-align: center;
  align-items: center;
  font-size: 0.875rem;
  position: fixed;
  right: 10px;
  transition-duration: 0.15s;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  z-index: 1000;
  max-height: 350px;
  bottom: 15px;
}

@media (max-width: 600px) {
  .alert {
    right: 22px;
  }
}
@media (min-width: 601px) {
  .alert {
    right: 10px;
  }
}

.alert-detail {
  max-width: 342px;
  -webkit-box-align: center;
  align-items: center;
  font-size: 0.875rem;
  position: fixed;
  right: 10px;
  transition-duration: 0.15s;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  z-index: 1000;
  max-height: 350px;
  bottom: 80px;
  width: 342px;
}

.alert-detail .header {
  padding-top: 5mm;
  text-align: center;
  height: 100%;
}

.alert-detail .image {
  width: 90mm;
  height: 75mm;
}
</style>
